import React from "react";
import "./Logo.css"

const Logo = () => {
  return (
    <a href="#section1">
    <div className="loader">
      <span>PAVO</span>
      <span>PAVO</span>
    </div>
    </a>
  );
};

export default Logo;
